import { Box, Button, Grid2, Typography } from "@mui/material";
import Warning from "Components/Common/Warning";
import React from "react";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "& .interviewBox": {
    cursor: "pointer",
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "& button": {
      width: "fit-content",
    },
  },
});

const SkillSection = () => {
  return (
    <>
      <Grid2 sx={styles}>
        <Typography fontWeight={500} variant="title" display={"flex"}>
          Skill Certificates (0)
        </Typography>
        <Warning>
          <Typography>
            <Typography fontWeight={500} variant="subtitle">
              Please Note:
            </Typography>
            The names on your skill certificates are derived from your profile
            details at the time of certificate creation.
          </Typography>
        </Warning>
        <Grid2 container spacing={2} columns={{ xl: 12, lg: 12, md: 6, sm: 6 }}>
          {[...Array(15)]?.map((item, i) => {
            return (
              <Grid2 className="interviewBox" key={i} size={3}>
                <PrimaryIcon icon={LockIcon} />
                <Box>
                  <Typography fontWeight={500} variant="subtitle">
                    Python Libraries
                  </Typography>
                  <Typography color="secondary.light">
                    Mock Interview Locked
                  </Typography>
                </Box>
                <Button variant="outlined">View More</Button>
              </Grid2>
            );
          })}
        </Grid2>
      </Grid2>
    </>
  );
};

export default SkillSection;
